import * as angular from "angular";
import {IController} from "angular";

export class adminUsersTableRowCtrl implements IController {
  user: any;
  roles: any;
  groups: any;
  isMobile: boolean;
  isShowLastActiveColumn: boolean;

  private isShowDeleteIcon: boolean;

  /* @ngInject */
  constructor(private $mdMedia) {
  }

  $onInit() {
    this.isShowDeleteIcon = false;
  }

    swipeLeft() {
    this.isShowDeleteIcon = this.isMobile;
  }

  swipeRight() {
    this.isShowDeleteIcon = false;
  }

}

angular
  .module('bringoz.admin.admins')
  .component('adminUsersTableRow', {
    require: {
      adminUsersTableCtrl: '^adminUsersTable'
    },
    bindings: {
      user: '<',
      roles: '<',
      groups: '<',
      isMobile: '<',
      isShowLastActiveColumn: '<?'
    },
    template: require('./admin-users-table-row.html').default,
    controller: adminUsersTableRowCtrl
  });
